export const DISCOUNT_CODE_FORM_NAME = 'discountCode'
